export default __webpack_public_path__ + "static/media/bernygroup2.37ca6014.jpg";